import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">
            Conteúdo SEO
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
            Artigos CSSBuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-xl mx-auto">
            Guias, comparações e dicas atualizadas para comprar da China com o melhor agente
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="bg-white rounded-2xl overflow-hidden border border-background-200 cursor-pointer group transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-full h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime} leitura</span>
                </div>
                <h3 className="text-foreground-950 font-bold text-sm md:text-base leading-snug group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm mt-2 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-primary-500 text-xs font-semibold">
                  Ler artigo
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/artigo/cssbuy-spreadsheet-guia-completo"
            className="inline-flex items-center gap-1 text-primary-500 font-semibold text-sm hover:text-primary-600 transition-colors duration-200 cursor-pointer"
          >
            Ver Guia Completo
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}